/**
 * Blocks pinch-zoom and multi-touch scale gestures on mobile (viewport meta alone is not always enough).
 */
export function preventMobileZoom() {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  const opts = { passive: false };

  const blockPinch = (event) => {
    if (event.touches && event.touches.length > 1) {
      event.preventDefault();
    }
  };

  const blockGesture = (event) => {
    event.preventDefault();
  };

  document.addEventListener("touchmove", blockPinch, opts);
  document.addEventListener("gesturestart", blockGesture, opts);
  document.addEventListener("gesturechange", blockGesture, opts);
  document.addEventListener("gestureend", blockGesture, opts);
}
